import { render, staticRenderFns } from "./xzJobNewsDetail.vue?vue&type=template&id=0818624a"
import script from "./xzJobNewsDetail.vue?vue&type=script&lang=js"
export * from "./xzJobNewsDetail.vue?vue&type=script&lang=js"
import style0 from "./xzJobNewsDetail.vue?vue&type=style&index=0&id=0818624a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports